import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import type { GitAction } from './actions.enum';

export interface GitMergeTreeAction extends WorkerAction {
  type: GitAction.MergeTree;
  params: { branch1: string; branch2: string };
}

export class GitMergeTreeActionError extends WorkerActionError {}

export async function GitMergeTreeActionFn({ lg, params }: WorkerFnParams<GitMergeTreeAction>): Promise<string> {
  try {
    const { branch1, branch2 } = params;
    return lg.callAndCaptureOutput(['merge-tree', branch1, branch2]);
  } catch (err) {
    throw new GitMergeTreeActionError(err);
  }
}
